var render = function render(){var _vm=this,_c=_vm._self._c;return _c('theme-comp-switch',_vm._g(_vm._b({attrs:{"defaultComp":_vm.defaultModal,"lalamoveComp":_vm.lalamoveModal}},'theme-comp-switch',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }